import React from 'react'
import { FaBars } from 'react-icons/fa';

const TopBar = ({page}) => {
  return (
    <div class="home-content bg-dark text-light">
        <i class="text-light" onClick={() => {
            let sidebar = document.querySelector(".sidebar");
            sidebar.classList.toggle("close");
        }}><FaBars /></i>
        <span class="text text-light">{page}</span>
    </div>
  )
}

export default TopBar